import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { NotFoundPage } from './pages/not-found/not-found.page';
import {
  ROUTE_MY_POSTS,
  ROUTE_WORLD_FEED,
  ROUTE_INNER_CIRCLE_FEED,
  ROUTE_CONNECTIONS_FEED,
  ROUTE_NEWS_FEED,
  NEW_SIGN_IN_PAGE_URL,
  WORD_CONNECTION_ONLY,
  WORD_INNER_CIRCLE,
  WORD_WORLD,
  ROUTE_REQUESTS_INBOX,
  ROUTE_REQUESTS_SENT,
  ROUTE_REQUESTS_SEND,
  ROUTE_REQUESTS_DETAIL,
  ROUTE_PEOPLE_INNER_CIRCLE,
  ROUTE_PEOPLE_CONNECTION_ONLY,
  ROUTE_NOTIFICATIONS,
} from './myConstants/app.constants';

export const routes: Routes = [
  {
    path: '',
    redirectTo: ROUTE_WORLD_FEED.substring(1),
    pathMatch: 'full'
  },


  {
    path: '',
    loadComponent: () => import('./pages/app-home/app-home.page').then(m => m.AppHomePage),

    children: [


      // Auth
      // { path: 'auth/login', loadComponent: () => import('./pages/auth/login/login.page').then(m => m.LoginPage) },
      // { path: 'auth/register', loadComponent: () => import('./pages/auth/register/register.page').then(m => m.RegisterPage) },

      // Posts
      { path: 'posts/create', canActivate: [authGuard], loadComponent: () => import('./pages/post/post-form/post-form.page').then(m => m.PostFormPage) },
      { path: 'posts/edit/:key', canActivate: [authGuard], loadComponent: () => import('./pages/post/post-form/post-form.page').then(m => m.PostFormPage) },
      { path: 'posts/view/:key', loadComponent: () => import('./pages/post/post-view/post-view.page').then(m => m.PostViewPage) },
      { path: ROUTE_MY_POSTS.substring(1), loadComponent: () => import('./pages/post/my-posts/my-posts.page').then(m => m.MyPostsPage) },
      { path: 'posts/lookup', loadComponent: () => import('./pages/post/post-lookup/post-lookup.page').then(m => m.PostLookupPage) },

      // Feeds
      { path: ROUTE_INNER_CIRCLE_FEED.substring(1), canActivate: [authGuard], loadComponent: () => import('./pages/feeds/feed/feed.page').then(m => m.FeedPage), data: { tab: WORD_INNER_CIRCLE } },
      { path: ROUTE_CONNECTIONS_FEED.substring(1), loadComponent: () => import('./pages/feeds/feed/feed.page').then(m => m.FeedPage), data: { tab: WORD_CONNECTION_ONLY } },
      { path: ROUTE_WORLD_FEED.substring(1), loadComponent: () => import('./pages/feeds/feed/feed.page').then(m => m.FeedPage), data: { tab: WORD_WORLD } },
      { path: ROUTE_NEWS_FEED.substring(1), canActivate: [authGuard], loadComponent: () => import('./pages/feeds/news/news.page').then(m => m.NewsPage) },

      // People
      { path: ROUTE_PEOPLE_INNER_CIRCLE.substring(1), loadComponent: () => import('./pages/peoples/people-list/people-list.page').then(m => m.PeopleListPage), data: { filter: 'circle-members' } },
      { path: ROUTE_PEOPLE_CONNECTION_ONLY.substring(1), loadComponent: () => import('./pages/peoples/people-list/people-list.page').then(m => m.PeopleListPage), data: { filter: 'my-connections' } },
      { path: 'people/:id', loadComponent: () => import('./pages/peoples/person-view/person-view.page').then(m => m.PersonViewPage) },

      // Requests
      { path: ROUTE_REQUESTS_SEND.substring(1), loadComponent: () => import('./pages/requests/send-request/send-request.page').then(m => m.SendRequestPage) },
      { path: ROUTE_REQUESTS_SENT.substring(1), loadComponent: () => import('./pages/requests/sent-requests/sent-requests.page').then(m => m.SentRequestsPage) },
      { path: ROUTE_REQUESTS_INBOX.substring(1), loadComponent: () => import('./pages/requests/inbox/inbox.page').then(m => m.InboxPage) },
      { path: ROUTE_REQUESTS_DETAIL.substring(1) + '/:id', loadComponent: () => import('./pages/requests/request-detail/request-detail.page').then(m => m.RequestDetailPage) },

      // Blocked
      { path: 'blocked-users', canActivate: [authGuard], loadComponent: () => import('./pages/blocked-users/blocked-users.page').then(m => m.BlockedUsersPage) },

      // Notifications
      { path: ROUTE_NOTIFICATIONS.substring(1), canActivate: [authGuard], loadComponent: () => import('./pages/notifications/notifications.page').then(m => m.NotificationsPage) },

      // About
      { path: 'about', loadComponent: () => import('./pages/about/about.page').then(m => m.AboutPage) },
      { path: 'faq', loadComponent: () => import('./pages/faq/faq.page').then(m => m.FaqPage) },

      // Profile
      { path: 'my-profile', loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage) },
      { path: 'profiles/:profileId', loadComponent: () => import('./pages/profile/public-profile/public-profile.page').then(m => m.PublicProfilePage) },

       // new Account and Profile
      { path: NEW_SIGN_IN_PAGE_URL.substring(1), loadComponent: () => import('./pages/new-account/account.page').then(m => m.AccountPage) },

      // 'account/action' was named 'pages/auth-actions'
      { path: 'account/action', loadComponent: () => import('./pages/auth-actions/auth-actions.page').then((m) => m.AuthActionsPage, ), },
      


    ],
  },




  // { path: '**', redirectTo: 'feed/world' },

 {
    path: '**',
    component: NotFoundPage, // eager loaded → instant
    // you can read the bad path from ActivatedRoute snapshot if you want to display it
  },
  
];
